import DraxLogo, { DraxLogoProps } from './DraxLogo';

const DraxMobileLogo = (props: DraxLogoProps) => <DraxLogo {...props} width={90} height={45} />;

export default DraxMobileLogo;
